import { CoreIcon } from '../core-icon';
import syncSVG from '../../assets/icons/sync.svg';
import type { IconProps } from '../core-icon';

export const SyncIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={syncSVG} {...props} />;
};
